import { render, staticRenderFns } from "./selectDialog.vue?vue&type=template&id=c38f2a18&scoped=true"
import script from "./selectDialog.vue?vue&type=script&lang=js"
export * from "./selectDialog.vue?vue&type=script&lang=js"
import style0 from "./selectDialog.vue?vue&type=style&index=0&id=c38f2a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38f2a18",
  null
  
)

export default component.exports